import { produce } from 'immer';
import config from '../config';
import actions from './index';

const getDuckStore = (dispatch, getState) => {
    const topStore = getState()[config.reduxStoreName];
    const { imStore = {} } = topStore;
    const store = {
        state: imStore,
        commit: chainAction(dispatch),
        dispatch: chainAction(dispatch),
        reduxDispatch: dispatch,
        reduxStore: { ...topStore, imStore: undefined },
    };
    return store;
};

const chainAction = dispatch => {
    return (actionName, payload) => {
        if (actions[actionName]) {
            dispatch(actions[actionName](payload));
        } else {
            console.error(`Trying to dispatch a non-existing action [${actionName}]`);
        }
    };
};

export const transformActionToThunk = vueAction => {
    return function actionCreator(...data) {
        if (typeof vueAction === 'function') {
            return function thunk(dispatch, getState) {
                const store = getDuckStore(dispatch, getState);
                vueAction(store, ...data);
                // vueAction.apply(undefined, [store, ...data])
            };
        } else {
            return () => undefined;
        }
    };
};

export const transformMutationToThunk = mutation => {
    return data => {
        if (typeof mutation === 'function') {
            return (dispatch, getState) => {
                const actionType = mutation.name;
                const store = getDuckStore(dispatch, getState);
                const patch = [];
                produce(
                    store.state,
                    draft => {
                        mutation({ ...store, state: draft }, data);
                    },
                    (patches, inversePatches) => {
                        patch.push(...patches);
                    }
                );
                dispatch({
                    type: 'IM-VUE/' + actionType,
                    isPatch: true,
                    payload: patch,
                });
            };
        }
    };
};

export function connectSDKtoAction(store, action) {
    return (...args) => {
        const thunkCreator = transformActionToThunk(action);
        const thunk = thunkCreator.apply(undefined, args);
        store.reduxDispatch(thunk);
    };
}
